
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {mechanismApi} from "@/api/organization";
    import {inspectionOrderApi} from "@/api/inspection";
    import InstrumentListMini from "@/components/InstrumentListMini.vue";
    import InstrumentList from "@/components/InstrumentList.vue";
    import InstrumentSubmit from "@/components/InstrumentSubmit.vue";
    import baseUrl, {imageUrl} from "@/constants";

    @Component({
        name: "inspectionEdit",
        components: {InstrumentListMini,InstrumentSubmit, InstrumentList}
    })
    export default class Home extends Vue {
        title = "审核详情";
        pageType = "0";  //0添加  1编辑  2查看
        id = "0";   //id
        listData = [] as any;  //详情返回数据
        form = {
            orderApplyNumber: "",
            checkMethod: "", //检定方式：0：现场检定 1：送检定机构实验室检定
            ownerName: "",
            userName: "",
            userMobile: "",
            updateTime: "",
            proveFileUrl: "",//已具证文件路径
            // promise: [],  //自我承诺勾选
        }
        rules = {
            // promise: [{ type: 'array', required: true, message: '提交时，必须勾选“自我承诺   ”', trigger: 'change' }],
            checkMethod: [{ required: true, message: '请选择本次检定方式', trigger: 'change' }],
            // userName: [{ required: true, message: '请输入发起人', trigger: 'blur' }],
            // userMobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        }
        setDialog = false;
        userData = null as any;
        private closePage: any;
        private exportReport: any;
        submitDialog = false;  //弹窗
        checkResult = -1; //0自动 4手动 这个是提交检定用来判断是自动分配检测机构还是手动分配检测机构
        checkType = -1;
        submitList = [];  //提交预览
        dialogForm = {} as any; //器具列表搜索条件
        technicalDepartId = "";
        mechanismTestList = [];//检定机构列表
        allSelected = [];
        waitSubmit = {
            visible: false,
            instrList: [],
        }
        orderId = "0";
        loading = false;
        submitLoading = false;
        created() {
            this.init();
        }
        lookInstruments(instrList: any){
            this.waitSubmit.instrList = instrList;
            this.waitSubmit.visible = true;
        }
        downFileV2(){
            window.open(baseUrl + "/file/download?file=" + this.form.proveFileUrl + "&name=器具证明材料", '_blank');
        }
        init(){
            this.pageType = this.$route.params.type;
            this.id = this.$route.params.id;
            this.orderId = String(this.$route.params.orderId);
            if(this.orderId !== '0'){
                this.getListDetail();
                return;
            }
            if(this.pageType != "0"){
                this.getDetail();
            }else{
                this.getUserData();
            }
            this.listTestMechanism();
        }
        //检定点击申请具证按钮
        onAppProveBtn(){
            this.$confirm('我省无法检定或校准的计量器具，需向上一级检定机构溯源的点击此处开具证明?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.saveBtn2(2);
            })
        }
        refresh(e:any) {
            this.dialogForm = JSON.parse(JSON.stringify(e));
        }
        //获取登录人数据填入form
        getUserData(){
            this.userData = this.$store.state.AuthedUser;
            this.form.userName = this.userData.name;
            this.form.userMobile = this.userData.phone;
            this.form.ownerName = this.userData.organizationName;
        }
        //获取器具详情
        getDetail(){
            inspectionOrderApi.getOrderDetail({id:this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.listData = rData.instruments;
                    this.form.userName = rData.inspectionOrder.userName;
                    this.form.userMobile = rData.inspectionOrder.userMobile;
                    this.form.ownerName = rData.inspectionOrder.ownerName;
                    this.form.checkMethod = rData.inspectionOrder.checkMethod;
                }
            })
        }
        //获取小订单的详情 -- 2022-3-22
        getListDetail(){
            inspectionOrderApi.listDetails({orderId:this.orderId, orderApplyId: this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.listData = rData.instruments;
                    this.form.orderApplyNumber = rData.orderApplyNumber;
                    try {
                        const jsonContent = JSON.parse(rData.jsonContent);
                        if(jsonContent && jsonContent['prove']){
                            this.form.proveFileUrl = jsonContent['prove'];
                        }
                    }catch (e) {
                        console.log(e);
                    }
                    this.form.userName = rData.initiatorName;
                    this.form.userMobile = rData.initiatorMobile;
                    this.form.ownerName = rData.initiatorMechanismName;
                    this.form.checkMethod = rData.checkMethod;
                    if(rData.createTime){
                        this.form.updateTime = rData.createTime.slice(0,10);
                    }
                }
            })
        }
        addList(){
            this.setDialog = true;
            this.$nextTick(()=>{
                const $listData = this.$refs.instrumentList as HTMLFormElement;
                $listData.handleClick();
                $listData.toggleSelection(this.listData);
            })
        }
        removeCheck(){
            const idArr = this.allSelected.flatMap((e: any) => e.id);
            if (idArr.length == 0) {
                this.$message.error("请勾选要移除的器具");
                return;
            }
            const lData = JSON.parse(JSON.stringify(this.listData));
            idArr.forEach((e:any)=>{
                const index = lData.findIndex((e2: any) => e2.id === e);
                if(index !== -1){
                    lData.splice(index, 1);
                }
            });
            this.listData = lData;
            this.allSelected = [];
            this.clearTable();
        }
        saveBtn() {
            const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
            $instrumentList.getCheckData((dataArr: Array<any>) => {
                this.listData = dataArr;
                this.setDialog = false;
            });
        }
        //查检定器具机构
        listTestMechanism(){
            mechanismApi.listMechanismV2({organizationType: ['0001', '0006' , '0008'].join(",")}).then((r) => {
                if(r.data.result === 0){
                    this.mechanismTestList = r.data.data;
                }
            });
        }

        submitBtn() {
            let form = this.$refs.form as HTMLFormElement;
            let form1 = this.$refs.form1 as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    form1.validate((valid1: any) => {
                        if (valid1) {
                            if (this.listData.length == 0) {
                                this.$message.error("器具检定列表不能为空");
                                return;
                            }

                            const data = this.listData[0];
                            this.checkResult = data.checkResult.value;
                            this.checkType = data.checkType;
                            //0是待检定 自动分配 检测机构
                            if (this.isSelectTestOrg(data.checkResult.value, data.checkType)) {
                                this.submitDialog = true;
                                return;
                            }
                            this.loading = true;
                            //1是检定终止状态  手动选择检测机构
                            const ids = this.listData.flatMap((e: any) => {
                                return e.id
                            });
                            inspectionOrderApi.assignTestOrg({
                                orderId: this.id,
                                instrumentIds: ids.join(",")
                            }).then((r: any) => {
                                this.loading = false;
                                if (r.data.result == 0) {
                                    const rData = r.data.data;
                                    this.submitList = rData;
                                    this.submitDialog = true;
                                }
                            })
                        }
                    });
                }else{
                    this.$message.warning("未填写完整信息");
                }
            });
        }

        //是否需要选择检测机构
        isSelectTestOrg(checkResult: number, checkType: number){
            if(checkResult === 3 && checkType === 2) { //（未受理） 已接收
                return true;
            }else if((checkResult === 0 || checkResult === 1 ||
                checkResult === 2|| checkResult === 3 || checkResult === 5 ||
                checkResult === 12  || checkResult === 13 || checkResult === 14 || checkResult === 15) && checkType === 5) { //（未检定 已检定 待报检 未受理 已超期 已终止） 免备案
                return true;
            }else{
                return false;
            }
        }
        clearTable(){
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
        }
        //type 0 保存  1提交 2 申请具证
        saveBtn2(type: number){
            let form1 = this.$refs.form1 as HTMLFormElement;
            form1.validate((valid:any) => {
                if (valid) {
                    const ids = this.listData.flatMap((e:any)=>{return e.id});
                    let params = {
                        instrumentIds: ids.join(","),
                        ...this.form,
                        submitType: type === 2 ? 1 : type,
                        technicalDepartId: "",
                    }
                    params = Object.assign(params, {orderId: this.id});
                    if(type == 1 && this.isSelectTestOrg(this.checkResult, this.checkType)){
                        if(!this.technicalDepartId){
                            this.$message.warning("请选择检定机构！");
                            return;
                        }
                        params.technicalDepartId = this.technicalDepartId;
                    }
                    //申请具证 指定机构ID默认-1
                    if(type === 2){
                        params.technicalDepartId = "-1";
                    }
                    const loading = this.$loading({
                        text: '正在保存。。。',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    inspectionOrderApi.submitInstrumentApp(params).then(r=>{
                        if(r.data.result == 0){
                            this.$message.success("保存成功");
                            this.closePage();
                        }
                        loading.close();
                    })
                }
            })
        }
        //删除整个任务
        deleteBtn(){
            this.$confirm('确定要删除吗？此操作不可逆转。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                inspectionOrderApi.deleteOrder({id: this.id}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.closePage();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        //导出页面
        downFile() {
            const loading = this.$loading({
                text: '正在导出',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                const pdfDom = this.$refs.pdfDom as HTMLFormElement;
                this.exportReport(pdfDom, "强检计量器具检定申请表", () => {
                    loading.close();
                });
            }, 1000);
        }

        instrDetail(data: any){
            let id = data.id;
            //检定单位任务列表中的器具id不同
            if(this.orderId !== '0'){
                id = data.instrumentId;
            }
            this.$router.push("/qj/instrument/detail/2/" + id);
        }

        memberSelectAll(selections: any){
            this.memberSelect(selections);
        }
        memberSelect(selections: any) {
            this.allSelected = selections;
        }

        mutexCheck(checkResult: number, checkType: number){
            let type = 0;
            if((checkResult === 1 || checkResult === 5 || checkResult === 0) && checkType === 2){
                type = 1;
            }else if(checkResult === 3 && checkType === 2){
                type = 2;
            }else if((checkResult === 1 || checkResult === 5 || checkResult === 0) && checkType === 5){
                type = 3;
            }else if(checkResult === 3 && checkType === 5){
                type = 4;
            }
            return type;
        }
    }
